import React from "react";
import { useSelector } from "react-redux";

import one from '../../assest/ex.jpg';
import two from '../../assest/exone.jpg';
import three from '../../assest/extwo.jpg';

// Images
import excavatorImg from '../../assest/heavy.jpg';
import FaqSection from "../../components/about/FAQ";
import ServicesCard from "../../components/home/ServicesCard";

const translations = {
    gb: {
        heading: "Excavators",
        buttonText: "Explore Excavator Services",
        introText: "Our excavators are engineered for superior performance in the toughest conditions. Perfect for construction, landscaping, and excavation projects, our machines deliver exceptional digging power, precision, and reliability to get the job done efficiently.",
        categoriesTitle: "Our Excavator Models",
        featuredTitle: "Featured Excavators",
        featuredDescription: "Excavators are versatile heavy machines designed for digging foundations, trenches, and handling materials with precision and efficiency on construction sites.",
        whyChooseTitle: "Why Choose Our Excavators?",
        specsLabel: "Specs:"
    },
    sa: {
        heading: "الحفارات",
        buttonText: "استكشف خدمات الحفارات",
        introText: "تم تصميم حفاراتنا لتقديم أداء متميز في أصعب الظروف. مثالية لمشاريع البناء والحفر وتنسيق الحدائق، توفر آلاتنا قوة حفر استثنائية ودقة وموثوقية لإنجاز العمل بكفاءة.",
        categoriesTitle: "موديلات الحفارات لدينا",
        featuredTitle: "الحفارات المميزة",
        featuredDescription: "الحفارات هي آلات ثقيلة متعددة الاستخدامات مصممة لحفر الأساسات والخنادق ومعالجة المواد بدقة وكفاءة في مواقع البناء.",
        whyChooseTitle: "لماذا تختار حفاراتنا؟",
        specsLabel: "المواصفات:"
    },
    fr: {
        heading: "Excavatrices",
        buttonText: "Explorer les services d'excavatrices",
        introText: "Nos excavatrices sont conçues pour offrir des performances supérieures dans les conditions les plus difficiles. Idéales pour les projets de construction, d'aménagement paysager et d'excavation, nos machines offrent une puissance de creusement exceptionnelle, une précision et une fiabilité pour accomplir le travail efficacement.",
        categoriesTitle: "Nos modèles d'excavatrices",
        featuredTitle: "Excavatrices en vedette",
        featuredDescription: "Les excavatrices sont des machines lourdes polyvalentes conçues pour creuser des fondations, des tranchées et manipuler des matériaux avec précision et efficacité sur les chantiers de construction.",
        whyChooseTitle: "Pourquoi choisir nos excavatrices?",
        specsLabel: "Spécifications :"
    },
    de: {
        heading: "Bagger",
        buttonText: "Bagger-Dienstleistungen erkunden",
        introText: "Unsere Bagger sind für überlegene Leistung unter den härtesten Bedingungen konzipiert. Perfekt für Bau-, Landschafts- und Ausgrabungsprojekte, bieten unsere Maschinen außergewöhnliche Grabkraft, Präzision und Zuverlässigkeit, um die Arbeit effizient zu erledigen.",
        categoriesTitle: "Unsere Bagger-Modelle",
        featuredTitle: "Vorgestellte Bagger",
        featuredDescription: "Bagger sind vielseitige schwere Maschinen, die für das Graben von Fundamenten, Gräben und die Handhabung von Materialien mit Präzision und Effizienz auf Baustellen entwickelt wurden.",
        whyChooseTitle: "Warum unsere Bagger wählen?",
        specsLabel: "Spezifikationen:"
    }
};

const excavatorList = [
    {
        name: {
            gb: "Compact Excavator",
            sa: "حفارة مدمجة",
            fr: "Excavatrice compacte",
            de: "Kompaktbagger"
        },
        image: one,
        specs: {
            gb: "Ideal for small to medium-scale digging tasks in tight spaces.",
            sa: "مثالية لأعمال الحفر الصغيرة إلى المتوسطة في المساحات الضيقة.",
            fr: "Idéal pour les travaux de creusement de petite à moyenne échelle dans des espaces restreints.",
            de: "Ideal für kleine bis mittelgroße Grabungsarbeiten in engen Räumen."
        },
        description: {
            gb: "Compact excavators are perfect for urban construction, landscaping, and small-scale excavation projects, offering precision and maneuverability.",
            sa: "الحفارات المدمجة مثالية للبناء الحضري وتنسيق الحدائق ومشاريع الحفر الصغيرة، وتوفر دقة وسهولة في المناورة.",
            fr: "Les excavatrices compactes sont parfaites pour la construction urbaine, l'aménagement paysager et les petits projets d'excavation, offrant précision et maniabilité.",
            de: "Kompaktbagger sind ideal für städtischen Bau, Landschaftsbau und kleine Grabungsprojekte und bieten Präzision und Wendigkeit."
        },
    },
    {
        name: {
            gb: "Standard Excavator",
            sa: "حفارة قياسية",
            fr: "Excavatrice standard",
            de: "Standardbagger"
        },
        image: two,
        specs: {
            gb: "Versatile machine for medium to large-scale construction and excavation.",
            sa: "آلة متعددة الاستخدامات للبناء والحفر من المستوى المتوسط إلى الكبير.",
            fr: "Machine polyvalente pour les travaux de construction et d'excavation de moyenne à grande envergure.",
            de: "Vielseitige Maschine für mittelgroße bis große Bau- und Grabungsarbeiten."
        },
        description: {
            gb: "Standard excavators provide robust digging power for foundations, trenches, and material handling on diverse construction sites.",
            sa: "تقدم الحفارات القياسية قوة حفر قوية للأساسات والخنادق ومناولة المواد في مواقع البناء المختلفة.",
            fr: "Les excavatrices standard offrent une puissance de creusement robuste pour les fondations, les tranchées et la manutention des matériaux sur divers chantiers.",
            de: "Standardbagger bieten starke Grabkraft für Fundamente, Gräben und Materialhandhabung auf verschiedenen Baustellen."
        },
    },
    {
        name: {
            gb: "Large Excavator",
            sa: "حفارة كبيرة",
            fr: "Grande excavatrice",
            de: "Großbagger"
        },
        image: three,
        specs: {
            gb: "Heavy-duty machine for large-scale excavation and mining operations.",
            sa: "آلة قوية لمهام الحفر والتعدين واسعة النطاق.",
            fr: "Machine robuste pour les opérations d'excavation et d'exploitation minière à grande échelle.",
            de: "Schwere Maschine für großflächige Grabungs- und Bergbauarbeiten."
        },
        description: {
            gb: "Large excavators are designed for major construction and mining projects, delivering unmatched power and efficiency for deep digging.",
            sa: "تم تصميم الحفارات الكبيرة للمشاريع الكبيرة والبناء والتعدين، وتوفر قوة وكفاءة لا مثيل لها للحفر العميق.",
            fr: "Les grandes excavatrices sont conçues pour les projets de construction et d'exploitation minière majeurs, offrant une puissance et une efficacité inégalées pour les travaux de creusement en profondeur.",
            de: "Großbagger sind für große Bau- und Bergbauprojekte konzipiert und bieten unvergleichliche Leistung und Effizienz für tiefes Graben."
        },
    }
];

const imageStyle = {
    height: '250px',
    width: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
};

const Excavators = () => {
    const { language } = useSelector((state) => state.language);
    const t = translations[language] || translations.gb;

    return (
        <div>
            {/* Introduction Text */}
            <section
                style={{
                    background: 'radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)',
                    padding: '20px',
                }}
            >
                <h1 className="text-center mb-4 mt-5">{t.heading}</h1>
                <p
                    className="text-center mb-5 mx-auto"
                    style={{ fontSize: '1.1rem', maxWidth: '70%' }}
                >
                    {t.introText}
                </p>
            </section>

            {/* Excavator Models */}
            <section className="container py-5">
                <h2 className="text-center mb-4">{t.categoriesTitle}</h2>
                <div className="row text-center">
                    {excavatorList.map((item, idx) => (
                        <div className="col-md-4 mb-4" key={idx}>
                            <img src={item.image} alt={item.name[language]} style={imageStyle} />
                            <h5 className="mt-3">{item.name[language] || item.name.gb}</h5>
                            <p><strong>{t.specsLabel}</strong> {item.specs[language] || item.specs.gb}</p>
                            <p>{item.description[language] || item.description.gb}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Featured Excavators */}
            <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <h2 className="text-center mb-4">{t.featuredTitle}</h2>
                    <p className="text-center mb-4">{t.featuredDescription}</p>

                    <ul className="list-group">
                        {excavatorList.map((item, idx) => (
                            <li key={idx} className="list-group-item mb-3">
                                <div className="row">
                                    <div className="col-md-3">
                                        <img src={item.image} alt={item.name[language]} style={imageStyle} />
                                    </div>
                                    <div className="col-md-9">
                                        <h5>{item.name[language] || item.name.gb}</h5>
                                        <p>{item.description[language] || item.description.gb}</p>
                                        <p><strong>{t.specsLabel}</strong> {item.specs[language] || item.specs.gb}</p>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <ServicesCard showHeading={false} showParagraph={false} />
            <FaqSection />
        </div>
    );
};

export default Excavators;
